// extracted by mini-css-extract-plugin
module.exports = {"root":"HTMLContent-root-5770ce4668399900d87c06ad10ba71a5 htmlContent-root-fe3506b39eaecd1a685ceda5e1292c4d"};